import { useMemo } from "react";
/**
 * Hook that returns cached Intl options (timezone and locale).
 * The values are computed once per component lifecycle and cached.
 *
 * Use this hook to avoid repeated Intl.DateTimeFormat instantiation,
 * which is expensive (~0.5-2ms per call).
 *
 * @returns Cached timezone and locale strings
 */ export function useCachedIntlOptions() {
    return useMemo(()=>{
        const resolved = Intl.DateTimeFormat().resolvedOptions();
        return {
            // Provide UTC fallback for edge cases where timeZone might be undefined
            timezone: resolved.timeZone ?? "UTC",
            locale: resolved.locale
        };
    }, []);
}
/**
 * Hook that returns a cached timezone string.
 * The timezone is computed once per component lifecycle and cached.
 *
 * Use this hook in grid view containers to get a cached timezone
 * that can be passed to column definitions, avoiding repeated
 * Intl.DateTimeFormat instantiation per cell render.
 *
 * @returns The user's system timezone (e.g., "America/New_York")
 */ export function useCachedTimezone() {
    return useCachedIntlOptions().timezone;
}
